import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Row, Col, Paragraph, Container, H4} from '@modifi/ui'

import {Wrapper, CaptionLight, StyledH4} from './styles'
import Picture from '../../ui/cms-picture'

const propTypes = {
  headline: PropTypes.string,
  isSmHeadlineOnLgOrLower: PropTypes.bool,
  imageUrl: PropTypes.string,
  imageCaption: PropTypes.string,
  description: PropTypes.string,
  backgroundColor: PropTypes.string,
  textAlign: PropTypes.oneOf(['left', 'right', 'center', '']),
}
const defaultProps = {
  headline: undefined,
  isSmHeadlineOnLgOrLower: false,
  imageUrl: '',
  imageCaption: '',
  description: undefined,
  backgroundColor: undefined,
  textAlign: 'center',
}

export type HeadlineWithDescriptionProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const HeadlineWithDescription: React.FC<HeadlineWithDescriptionProps> = ({
  headline,
  isSmHeadlineOnLgOrLower,
  imageUrl,
  imageCaption,
  description,
  backgroundColor,
  textAlign,
}) => (
  <Wrapper backgroundColor={backgroundColor} textAlign={textAlign}>
    <Container>
      {headline && (
        <Row>
          <Col col={12}>
            {isSmHeadlineOnLgOrLower ? <StyledH4>{headline}</StyledH4> : <H4>{headline}</H4>}
          </Col>
        </Row>
      )}
      {imageUrl && (
        <Row mt={16} mb={16}>
          <Col col={12}>
            <Picture alt={`${headline} image`} src={imageUrl} objectFit="cover" isBackgroundImage />
          </Col>
        </Row>
      )}
      {imageCaption && (
        <Row mt={16} mb={16}>
          <Col col={12}>
            <CaptionLight>{imageCaption}</CaptionLight>
          </Col>
        </Row>
      )}
      {description && (
        <Row>
          <Col col={12}>
            <Paragraph>{description}</Paragraph>
          </Col>
        </Row>
      )}
    </Container>
  </Wrapper>
)

HeadlineWithDescription.propTypes = propTypes

HeadlineWithDescription.defaultProps = defaultProps

export default HeadlineWithDescription
